import axios from "axios";
import url from "../utils/url";
const email = "deni@mail.com";
const itemService = {
  getDataAll: async () => {
    const response = await axios.get(`${url}/activity-groups?email=${email}`);
    const data = await response.data;
    return data;
  },
  getOneActivity: async (id) => {
    const response = await axios.get(`${url}/activity-groups/${id}`);
    const data = await response.data;
    return data;
  },
  createActivity: async () => {
    const add = await axios.post(`${url}/activity-groups`, {
      title: "activity",
      email: email,
    });
    return add;
  },
  deleteActivity: async (id) => {
    const response = await axios.delete(`${url}/activity-groups/${id}`);
    return response;
  },
  updateActivity: async (id, data) => {
    const update = await axios.patch(`${url}/activity-groups/${id}`, {
      ...data,
    });
    const res = await update.data;
    return res;
  },
  getAllTodos: async (id) => {
    const res = await axios.get(`${url}/todo-items?activity_group_id=${id}`);
    const data = await res.data;
    return data;
  },
  getOneTodo: async (id) => {
    const res = await axios.get(`${url}/todo-items/${id}`);
    const data = await res.data;
    return data;
  },
  AddTodo: async (data) => {
    const item = {
      activity_group_id: await data.id,
      title: await data.title,
      is_active: 1,
      priority: data.priority,
    };
    const res = await axios.post(`${url}/todo-items`, { ...item });
    return res;
  },
  deleteTodo: async (id) => {
    const res = await axios.delete(`${url}/todo-items/${id}`);
    return res;
  },
  updateTodo: async (id, data) => {
    const res = await axios.patch(`${url}/todo-items/${id}`, { ...data });
    return res;
  },
};

export default itemService;
